import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FileText, Megaphone } from 'lucide-react';

const icons = { course: BookOpen, assignment: FileText, announcement: Megaphone };

export default function NotificationDropdown({ notifications, onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 10, scale: 0.95 }}
      className="absolute right-0 top-full mt-2 w-80 bg-card rounded-xl shadow-2xl border overflow-hidden z-50"
    >
      <div className="p-4 border-b">
        <h3 className="font-heading font-semibold">Notifications</h3>
      </div>
      <div className="max-h-80 overflow-y-auto">
        {notifications.map(notif => {
          const Icon = icons[notif.type] || BookOpen;
          return (
            <div key={notif.id} className={`p-4 border-b last:border-0 hover:bg-muted/50 transition-colors cursor-pointer ${!notif.read ? 'bg-primary/5' : ''}`}>
              <div className="flex gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${!notif.read ? 'bg-primary/10' : 'bg-muted'}`}>
                  <Icon className={`w-4 h-4 ${!notif.read ? 'text-primary' : 'text-muted-foreground'}`} />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{notif.title}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{notif.message}</p>
                  <p className="text-xs text-muted-foreground/60 mt-1">{notif.time}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}